import { useQuery } from '@tanstack/react-query';
import { REFRESH_INTERVALS } from '../constants';

export interface SolarReading {
  city: string;
  latitude: number;
  longitude: number;
  shortwaveRadiation: number | null;
  directNormalIrradiance: number | null;
  diffuseRadiation: number | null;
  isDay: boolean;
  sunrise: string;
  sunset: string;
  sunshineDuration: number | null;
  timestamp: string;
}

export interface SolarCurrent {
  timestamp: string;
  readings: SolarReading[];
  islandAverage: {
    radiation: number | null;
    directNormalIrradiance: number | null;
    diffuseRadiation: number | null;
    sunshineDuration: number | null; // hours
    sunrise: string;
    sunset: string;
    isDay: boolean;
  } | null;
}

export function useSolar() {
  return useQuery({
    queryKey: ['solar', 'current'],
    queryFn: async (): Promise<SolarCurrent | null> => {
      const res = await fetch('/api/solar/current');
      if (!res.ok) return null; // Solar is optional
      return res.json();
    },
    refetchInterval: REFRESH_INTERVALS.current,
    staleTime: 30000,
  });
}
